import React, { useEffect, useState, useContext, Fragment, useRef } from 'react'
import '../css/sb-admin-2.min.css'
import '../css/sb-admin-2.css'

import Sidebar from '../Components/Sidebar';
import Topbar from '../Components/Topbar';
import $ from 'jquery';
import { AppColors } from '../css/AppColors';
import { Modal, Button, NavItem } from 'react-bootstrap';
import { apiRequest } from '../utils/apiCalls';
import { Context } from '../Context/DataContext';
import { Link, useLocation } from 'react-router-dom';

import { FaClipboardList, FaPencilAlt, FaTrash } from 'react-icons/fa'
import { useForceUpdate } from '../utils/functions';


const ViewOrder = () => {

    const forceUpdate = useForceUpdate();
    const { state, setCustomersGlobal } = useContext(Context)
    const location = useLocation();
    const [loading, setLoading] = useState(false)
    const [orders, setOrders] = useState([])
    const [orderArr, setOrdersArr] = useState([])
    const [delId, setDelId] = useState('')
    const [delModal, setDelModal] = useState(false)
    const [orderStatuses, setOrderStatuses] = useState([])
    const [changeOrderStatusId, setChangeOrderStatusId] = useState();
    const [changeOrderStatusModal, setChangeOrderStatusModal] = useState(false)
    const [changeOrderStatusOrderId, setChangeOrderStatusOrderId] = useState('')
    const [customers, setCustomers] = useState(state.customers ? state.customers : [])


    const [value, setValue] = useState("");
    const [showDropdown, setShowDropdown] = useState(false);
    const wrapperRef = useRef(null);
    const [suggestionArr, setSuggestionArr] = useState([])
    // const suggestionArr = customers.split(", ").filter(suggestion =>
    //         suggestion.toLowerCase().includes(value.toLowerCase())
    //     );



    function getOrders() {

        setLoading(true)
        apiRequest({ st_id: state.storeData.st_id }, 'viewOrders')
            .then(data => {
                console.log(data)
                if (data.status == '1') {
                    setOrdersArr(data.data)
                    console.log('location = ')
                    console.log(location.state)
                    if (location?.state?.cust_id) {
                        var c = data.data.filter(item => item.cust_id == location.state.cust_id)
                        setOrders(c)
                        // console.log('order are')
                        // console.log(c[0].cs)
                        setValue(c[0].cust_fname + " " + c[0].cust_lname)
                    }
                    else setOrders(data.data)
                    // setLoading(false)
                    getOrderStatuses();
                }
                else {
                    // alert(data.error)
                    setLoading(false)
                }
            })
            .catch(err => {
                setLoading(false);
                alert('Internet error');
            })
    }

    function getOrderStatuses() {
        setLoading(true)
        apiRequest({ st_id: state.storeData.st_id }, 'getOrderStatus')
            .then(data => {
                console.log(data)
                if (data.status == '1') {
                    setOrderStatuses(data.data)
                    setLoading(false)
                }
                else {
                    // alert(data.error)
                    setLoading(false)
                }
            })
            .catch(err => {
                setLoading(false);
                alert('Internet error');
            })
    }

    function doChangeOrderStatus(os_id, o_id) {
        setLoading(true)
        const reqObj = {
            st_id: state.storeData.st_id,
            os_id,
            o_id
            // : changeOrderStatusId,

            //  changeOrderStatusOrderId
        }
        apiRequest(reqObj, 'changeOrderStatus')
            .then(data => {
                console.log(data)
                if (data.status == '1') {
                    if (data.orders) {
                        setOrders(data.orders)
                        forceUpdate();
                    }
                    setLoading(false)
                }
                else {
                    setLoading(false)
                }
            })
            .catch(err => {
                setLoading(false);
                alert('Internet error');
            })
    }

    function delOrder() {

        const reqObj = {
            o_id: delId,
            st_id: state.storeData.st_id
        }
        console.log(reqObj)
        setLoading(true)
        apiRequest(reqObj, 'delOrder')
            .then(data => {
                console.log(data)
                if (data.status == '1') {
                    if (data.data) {
                        setLoading(false)
                        setOrders(data.data)
                        alert(data.msg)
                    }
                    else {
                        getOrders()
                        // setLoading(false)
                        alert(data.msg)
                    }
                }
                else {
                    setLoading(false)
                    alert(data.error)
                }
            })
            .catch(err => {
                setLoading(false)
                alert('Internet Error')
            })


    }

    function getCustomers() {

        setLoading(true)
        var st_id;
        st_id = state.storeData.st_id

        apiRequest({ st_id: st_id }, 'viewcustomers')
            .then(data => {

                setLoading(false)
                if (data.status == 1) {
                    setCustomers(data.data)
                    setCustomersGlobal(data.data)
                }

            })
            .catch(err => {
                setLoading(false)
                console.log(err)
            })
    }


    useEffect(() => {
        $(document).ready(function () {
            $('#dataTable').DataTable({
                responsive: true,
                searching: false, paging: false, info: false,
                language: {
                    emptyTable: "",
                    zeroRecords: ""
                },
                // "order": [[0, "desc"]]

            });
            // $('#dataTable').DataTable();
        });

    }, [loading])

    useEffect(() => {
        getOrders();
        if (!state.customers.length) {
            getCustomers()
        }

    }, [])



    return (
        <div
            onClick={() => setSuggestionArr([])}
            id="page-top">
            <div id="wrapper">
                <Sidebar />

                {/* Content Wrapper */}
                <div id="content-wrapper" className="d-flex flex-column">
                    {/* Main Content */}
                    <div id="content">
                        <Topbar />

                        {/* Begin Page Content */}
                        <div className="container-fluid">
                            <Modal
                                show={changeOrderStatusModal}
                                onHide={() => setDelModal(false)}
                            >
                                <Modal.Header>
                                    <Modal.Title style={{ fontSize: 18, textAlign: 'center', alignSelf: 'center', fontFamily: 'PSBo' }} >Are you sure you want to delete this order?</Modal.Title>
                                </Modal.Header>
                                <Modal.Footer>
                                    <Button
                                        style={{ fontFamily: 'PMe' }}
                                        variant="secondary" onClick={() => {
                                            setChangeOrderStatusId('')
                                            setChangeOrderStatusOrderId('')
                                            setChangeOrderStatusModal(false)
                                            forceUpdate();
                                        }}>No</Button>
                                    <Button
                                        style={{ fontFamily: 'PMe' }}
                                        variant="danger" onClick={() => {
                                            setChangeOrderStatusModal(false)
                                            doChangeOrderStatus()
                                        }}>Yes</Button>
                                </Modal.Footer>


                            </Modal>

                            <Modal
                                show={delModal}
                                onHide={() => setDelModal(false)}
                            >
                                <Modal.Header>
                                    <Modal.Title style={{ fontSize: 18, textAlign: 'center', alignSelf: 'center', fontFamily: 'PSBo' }} >Are you sure you want to delete this order?</Modal.Title>
                                </Modal.Header>
                                <Modal.Footer>
                                    <Button
                                        style={{ fontFamily: 'PMe' }}
                                        variant="secondary" onClick={() => {
                                            setDelId('')
                                            setDelModal(false)
                                        }}>No</Button>
                                    <Button
                                        style={{ fontFamily: 'PMe' }}
                                        variant="danger" onClick={() => {
                                            setDelModal(false)
                                            delOrder()
                                        }}>Yes</Button>
                                </Modal.Footer>


                            </Modal>

                            <Modal
                                show={loading}
                                onHide={() => setLoading(false)}
                            >

                                <Modal.Body class="text-center" >
                                    <div
                                        class="text-center"
                                        class="spinner-border text-center" style={{ margin: 10, color: AppColors.primary }} role="status"></div>
                                </Modal.Body>

                            </Modal>


                            {/* Page Heading */}
                            <div className="container-fluid">
                                {/* Page Heading */}
                                <div style={{ width: "100%", height: 65, }} className="col-lg-12" >
                                    <div style={{ float: "left", width: "50%" }}>
                                        <h1 className="h3 mb-2 text-gray-800">View Orders</h1>
                                        <br />
                                    </div>
                                    <div style={{ float: "right", display: 'flex', flexDirection: 'column', }}>
                                        <Button
                                            className="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm"
                                            style={{ color: 'white', backgroundColor: AppColors.primary, borderWidth: 0, marginTop: 10, fontFamily: 'RBo', }}

                                        >
                                            <Link
                                                style={{ color: 'white', textDecorationLine: 'none', }}
                                                to={{
                                                    pathname: "/addOrder",
                                                    state: {
                                                        cust: location?.state?.cust_id ? location?.state?.cust_id : null
                                                    }
                                                }}>
                                                Add Order
                                            </Link>
                                        </Button>
                                    </div>
                                    {/* <div style={{ float: "right", textAlign: "right", width: "50%" }}>
                                        <a
                                            href="add_order.php"
                                            className="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm"
                                        >
                                            <i className="fas fa-folder-plus fa-sm text-white-50" /> Add
                                            Order
                                        </a>
                                    </div> */}

                                </div>
                                {/* <div>
                                    <select
                                        name="cust_id"
                                        id="cust_id"
                                        className="form-control form-control-user"
                                        placeholder="No of Boxes"
                                        onChange={(v) => {
                                            console.log(v)
                                            // var obj = v.target.value;
                                            // obj = JSON.parse(obj)
                                            // getCustPresc(obj.cust_id)
                                            // setCust_id(obj.cust_id)
                                            // setCust(obj)

                                        }}
                                    >
                                        <option selected disabled>
                                            Select Customer
                                        </option>
                                        {
                                            customers.map((v) => {
                                                return (
                                                    <option value={JSON.stringify(v)}>{v.cust_fname} {v.cust_lname}</option>
                                                )

                                            })
                                        }
                                    </select>
                                </div> */}
                                <div className="input__wrapper" ref={wrapperRef}>
                                    <input
                                        type="text"
                                        style={{ fontFamily: 'PRe' }}
                                        placeholder={value ? value : "Search Customer"}
                                        className="form-control form-control-user"
                                        onChange={(v) => {

                                            var val = v.target.value
                                            setValue(val)
                                            console.log('val =' + val)
                                            if (!val.length) {
                                                setSuggestionArr([])
                                                setOrders(orderArr)
                                                return
                                            }
                                            try {
                                                var search = new RegExp(val, 'i'); // prepare a regex object
                                            }
                                            catch (err) {
                                                console.log(err)
                                            }
                                            var c = [];
                                            var i = 0;
                                            for (let key in customers) {
                                                if (val.indexOf(' ') >= 0) {
                                                    try {
                                                        if (search.test(customers[key].cust_fname + " " + customers[key].cust_lname)) {
                                                            c[i] = customers[i]
                                                        }
                                                    }
                                                    catch (err) { }

                                                }
                                                try {
                                                    if (search.test(customers[key].cust_fname) || search.test(customers[key].cust_lname) || search.test(customers[key].cust_phone)) {
                                                        c[i] = customers[i]
                                                    }
                                                }
                                                catch (err) { }

                                                i++;
                                            }
                                            setSuggestionArr(c)
                                            forceUpdate()
                                        }}
                                        onFocus={() => {
                                            setShowDropdown(true)
                                            setSuggestionArr(customers)
                                        }}
                                        value={value}
                                    />
                                    {/* {showDropdown && ( */}
                                    <div className="suggestions__dropdown" >
                                        {suggestionArr?.length > 0 ? (
                                            <div style={{ position: 'fixed', zIndex: 1000, backgroundColor: 'rgba(128,128,128,1)', width: "50%", borderRadius: 5, padding: 10 }}>
                                                {suggestionArr.map((v, index) => {
                                                    return (
                                                        <div style={{ marginTop: 0 }}>
                                                            <input
                                                                type="button"
                                                                style={{ width: "100%", textAlign: 'left', backgroundColor: 'rgba(128,128,128,1)', color: 'white', borderWidth: 0, fontFamily: 'PMe', fontSize: 14 }}

                                                                value={v.cust_id}
                                                                onClickCapture={() => {
                                                                    // alert('asd')
                                                                    var c = orderArr.filter(item => item.cust_id == v.cust_id)
                                                                    setOrders(c)
                                                                    setSuggestionArr([])
                                                                    setValue(v.cust_fname + " " + v.cust_lname)
                                                                    forceUpdate()
                                                                }}
                                                                // key={"suggestion_" + index}
                                                                // placeholder={v.cust_fname.toString()}
                                                                value={v.cust_fname.toString() + " " + v.cust_lname + " - " + v.cust_phone}
                                                            // onClick={() => setValue(v)}
                                                            />
                                                        </div>

                                                    )
                                                })}
                                            </div >
                                        ) : (
                                            null
                                            // <div className="no__suggestions">No suggestions found</div>
                                        )}
                                    </div>
                                    {/* )} */}
                                </div>

                                {/* DataTales Example */}

                                <div className="card shadow mb-4 mt-4" style={{ width: "100%" }} >

                                    <div className="card-body">
                                        {
                                            !loading &&

                                            <div className="table-responsive">
                                                {/* table class="table table-bordered dt-responsive" id="dataTable" width="100%" cellspacing="0" */}
                                                <table
                                                    id="dataTable"
                                                    className="table table-striped table-bordered dt-responsive display responsive nowrap"
                                                    style={{ width: "100%" }}
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th class="tRow" >Order No.</th>
                                                            <th class="tRow" >Customer</th>
                                                            <th class="tRow" >Date Time</th>
                                                            <th class="tRow" >No of items</th>
                                                            {/* <th class="tRow" >Status</th> */}
                                                            <th class="tRow" >Status</th>
                                                            <th className="tRow"> Action</th>
                                                        </tr>
                                                    </thead>
                                                    {/* <tfoot>
                                                    <tr>
                                                        <th>Order No.</th>
                                                        <th>Customer</th>
                                                        <th>Date Time</th>
                                                        <th>No of items</th>
                                                        <th>Status</th>
                                                        <th>Status1</th>
                                                    </tr>
                                                </tfoot> */}
                                                    <tbody>

                                                        {
                                                            orders.map((v) => {
                                                                return (
                                                                    <tr>
                                                                        <td className="tData">
                                                                            <nobr>
                                                                                <Link to={{
                                                                                    pathname: '/orderDetails',
                                                                                    state: v,
                                                                                }}
                                                                                    className="tData"
                                                                                    style={{ color: 'black' }}
                                                                                >

                                                                                    {v.o_id}
                                                                                </Link>
                                                                            </nobr>
                                                                        </td>
                                                                        <td className="tData">{v.cust_fname} {v.cust_lname}</td>
                                                                        <td className="tData">{v.o_datetime}<nobr /></td>
                                                                        <td className="tData">{v.no_of_items}</td>
                                                                        {/* <td className="tData">{v.os_id}</td> */}
                                                                        <td className="tData">
                                                                            <select
                                                                                // disabled={true}
                                                                                onChange={(t) => {
                                                                                    setChangeOrderStatusId(t.target.value);
                                                                                    setChangeOrderStatusOrderId(v.o_id);
                                                                                    forceUpdate();
                                                                                    doChangeOrderStatus(t.target.value, v.o_id);
                                                                                    // setChangeOrderStatusModal(true);
                                                                                }}
                                                                                name="product[]"
                                                                                className="form-control form-control-user cbo_product"
                                                                                placeholder="Select product"
                                                                                style={{ padding: "0px 0px 0px 10px" }}
                                                                            >
                                                                                {
                                                                                    orderStatuses?.map((item) => {
                                                                                        return (
                                                                                            <option
                                                                                                selected={v.os_id == item.os_id ? true : false}
                                                                                                value={item.os_id}
                                                                                            >
                                                                                                {item.os_status}
                                                                                            </option>
                                                                                        )
                                                                                    })
                                                                                }

                                                                            </select>
                                                                        </td>
                                                                        <td>
                                                                            <nobr>
                                                                                <Link to={{
                                                                                    pathname: '/orderDetails',
                                                                                    state: v,
                                                                                }}
                                                                                    className="btn" style={{ backgroundColor: '#54C2BB', }} >
                                                                                    <FaClipboardList color="white" />
                                                                                </Link>{" "}

                                                                                <Link to={{
                                                                                    pathname: "/editOrder",
                                                                                    state: v

                                                                                }}
                                                                                    className="btn" style={{ backgroundColor: '#54C2BB' }} >
                                                                                    <FaPencilAlt color="white" />
                                                                                </Link>{" "}
                                                                                <Button
                                                                                    onClick={() => {
                                                                                        setDelId(v.o_id)
                                                                                        setDelModal(true)
                                                                                    }}
                                                                                    className="btn btn-danger">
                                                                                    <FaTrash color="white" />
                                                                                </Button>
                                                                            </nobr>
                                                                        </td>
                                                                    </tr>

                                                                )
                                                            })
                                                        }





                                                    </tbody>
                                                </table>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* /.container-fluid */}
                    </div>
                    {/* End of Main Content */}
                </div>
                {/* End of Content Wrapper */}
            </div>
            {/* End of Page Wrapper */}
            {/* Scroll to Top Button*/}
            <a className="scroll-to-top rounded" href="#page-top">
                <i className="fas fa-angle-up" />
            </a>
            {/* Logout Modal*/}
            <div
                className="modal fade"
                id="logoutModal"
                tabIndex={-1}
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                                Ready to Leave?
                            </h5>
                            <button
                                className="close"
                                type="button"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            Select "Logout" below if you are ready to end your current session.
                        </div>
                        <div className="modal-footer">
                            <button
                                className="btn btn-secondary"
                                type="button"
                                data-dismiss="modal"
                            >
                                Cancel
                            </button>
                            <a className="btn btn-primary" href="logout.php">
                                Logout
                            </a>
                        </div>
                    </div>
                </div>
            </div>


        </div >
    )
}

export default ViewOrder
